// Transactions (PS)
const AccountingIndex = () => import('@/domain/accounting/index.vue')
const OrderItemDetail = () => import('@/domain/accounting/order/OrderItemDetail.vue')
const ServiceOrderDetail = () => import('@/domain/accounting/details/ServiceOrderDetail.vue')
const RefundDetail = () => import('@/domain/accounting/details/RefundDetail.vue')

// Movements (PS)
const MovementIndex = () => import('@/domain/accounting/movement/MovementIndex.vue')
const MovementOrderItemDetail = () => import('@/domain/accounting/movement/MovementOrderItemDetail.vue')
const MovementRefundDetail = () => import('@/domain/accounting/movement/MovementRefundDetail.vue')

// Chargebacks
const ChargebackList = () => import('@/domain/accounting/chargeback/ChargebackList.vue')
const ChargebackDetail = () => import('@/domain/accounting/chargeback/ChargebackDetail.vue')

export default [
    // Transactions
    {
        path: 'accounting',
        name: 'event.accounting',
        component: AccountingIndex,
        meta: {
            label: 'Transactions',
            title: 'Transactions',
            scopeType: 'pica-service',
            permission: 'pica_service.accounting.transactions.list'
        }
    },
    {
        path: 'accounting/order-item/:id',
        name: 'event.accounting.order-item',
        component: OrderItemDetail,
        meta: {
            label: 'Order Item Detail',
            scopeType: 'pica-service',
            permission: 'pica_service.accounting.order.detail'
        }
    },
    {
        path: 'accounting/service-order/:id',
        name: 'event.accounting.service-order',
        component: ServiceOrderDetail,
        meta: {
            label: 'Service Order Detail',
            scopeType: 'pica-service',
            permission: 'pica_service.accounting.service_order.detail'
        }
    },
    {
        path: 'accounting/refund/:id',
        name: 'event.accounting.refund',
        component: RefundDetail,
        meta: {
            label: 'Refund Detail',
            scopeType: 'pica-service',
            permission: 'pica_service.accounting.refund.detail'
        }
    },
    // Movements
    {
        path: 'movements',
        name: 'event.movements',
        component: MovementIndex,
        meta: {
            label: 'Movements',
            title: 'Movements',
            scopeType: 'pica-service',
            permission: 'pica_service.accounting.movements.list'
        }
    },
    {
        path: 'movements/order-item/:id',
        name: 'event.movements.order-item',
        component: MovementOrderItemDetail,
        meta: {
            label: 'Order Item Detail',
            scopeType: 'pica-service',
            permission: 'pica_service.accounting.order.detail',
            breadcrumb: (context) => ([
                {
                    text: 'Movements',
                    to: { name: 'event.movements', params: context.route.params }
                },
                { text: 'Order Item Detail' }
            ])
        }
    },
    {
        path: 'movements/refund/:id',
        name: 'event.movements.refund',
        component: MovementRefundDetail,
        meta: {
            label: 'Refund Detail',
            scopeType: 'pica-service',
            permission: 'pica_service.accounting.refund.detail',
            breadcrumb: (context) => ([
                {
                    text: 'Movements',
                    to: { name: 'event.movements', params: context.route.params }
                },
                { text: 'Refund Detail' }
            ])
        }
    },
    // Chargebacks
    {
        path: 'chargebacks',
        name: 'event.chargebacks',
        component: ChargebackList,
        meta: {
            label: 'Disputes',
            scopeType: 'pica-service',
            permission: 'pica_service.accounting.chargeback.list'
        }
    },
    {
        path: 'chargebacks/:id',
        name: 'event.chargebacks.detail',
        component: ChargebackDetail,
        meta: {
            label: 'Dispute Detail',
            scopeType: 'pica-service',
            permission: 'pica_service.accounting.chargeback.detail'
        }
    }
]
